import { Swiper } from 'swiper/bundle';

var solutionSliders = document.querySelectorAll('.slider-solutions');

solutionSliders.forEach((solutionSlider) => {
  initializeSwiper(solutionSlider);
});

function initializeSwiper(swiperInstance) {
  let sliderSolutionOptions = {
    speed: 1000,
    simulateTouch: false,
    navigation: {
      disabledClass: 'slider-control-disabled',
      hiddenClass: 'slider-control-hidden',
      lockClass: 'slider-control-lock',
      nextEl: swiperInstance.querySelector('.slider-solutions .slider-control-next'),
      prevEl: swiperInstance.querySelector('.slider-solutions .slider-control-prev'),
    },
    on: {
      init: function () {
        var pagerCurent = this.el.querySelector('.slider-pager-current'),
          pagerTotal = this.el.querySelector('.slider-pager-total');
        pagerCurent.innerHTML = '0' + (this.activeIndex + 1);
        pagerTotal.innerHTML = '0' + this.slides.length;
      },
      slideChange: function () {
        var currentSlide = '0' + (this.realIndex + 1);
        this.el.querySelector('.slider-pager-current').innerHTML = currentSlide;
      },
    },
    slideActiveClass: 'slider-item-active',
  };

  let sliderSolution = new Swiper(swiperInstance, sliderSolutionOptions);

  sliderSolution.on('slideChangeTransitionStart', function () {
    if (this.slides[this.realIndex].classList.contains('has-video')) {
      var video = this.slides[this.realIndex].getElementsByTagName('video');
      video[0].play();
    }
  });

  sliderSolution.on('slideChange', function () {
    Array.from(this.slides).forEach(function (slide) {
      if (slide.classList.contains('has-video')) {
        var video = slide.getElementsByTagName('video');
        video[0].classList.add('pause');
        video[0].pause();
      }
    });
  });
}

export { initializeSwiper };
